export default {"src":"/_next/static/media/about33.ed9dabdf.svg","height":246,"width":280};